import Axios, { AxiosStatic, AxiosRequestConfig, AxiosInstance, AxiosPromise, AxiosResponse } from 'axios';
import Vue from 'vue';
import router from '@/router';
import JwtDecode from 'jwt-decode';
import { RewistaTobaccoToken, RewistaTokens } from '@/customTypes';
export class RewistaTobaccoService {
    protected axios: AxiosInstance;
    private axiosConfig: AxiosRequestConfig = {
        baseURL: 'http://100.100.0.101:88/api/',
        headers: { 'Content-Type': 'application/json' },
    };
    constructor() {
        this.axios = Axios.create(this.axiosConfig);
        this.axios.interceptors.response.use(undefined, this.axiosRefreshInterceptor);
        this.axios.interceptors.request.use(this.axiosAuthRequestInterceptor);
    }

    public async axiosRefreshRequest(refreshToken: string): Promise<AxiosResponse<string>> {
        return this.axios.post<string>('token/RefreshToken', JSON.stringify(refreshToken));
    }
    protected axiosLoginStatus(tokens: RewistaTokens) {
        Vue.$cookies.set('authToken', tokens.accessToken);
        Vue.$cookies.set('refreshToken', tokens.refreshToken);
    }

    protected axiosLogoutStatus() {
        Vue.$cookies.remove('authToken');
        Vue.$cookies.remove('refreshToken');
    }
    private async axiosAuthRequestInterceptor(request: AxiosRequestConfig): Promise<AxiosRequestConfig> {
        if (Vue.$cookies.isKey('authToken')) {
            const accessToken = Vue.$cookies.get('authToken');
            request.headers.Authorization = `Bearer ${accessToken}`;
        }
        return request;
    }

    private async axiosRefreshInterceptor(error: any): Promise<any> {
        if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
            if (Vue.$cookies.isKey('refreshToken')) {
                const refreshToken = Vue.$cookies.get('refreshToken');
                const decodedRefreshToken = JwtDecode<RewistaTobaccoToken>(refreshToken);
                const exipirationDate = new Date(0);
                exipirationDate.setUTCSeconds(decodedRefreshToken.exp);
                if (new Date() > exipirationDate) {
                    router.push({ name: 'login' });
                } else {
                    const response = await this.axiosRefreshRequest(refreshToken);
                    if (response.status === 200) {
                        Vue.$cookies.set('authToken', response.data);
                        return this.axios.request(error.config);
                    } else {
                        router.push({ name: 'login' });
                    }
                }
            } else {
                router.push({ name: 'login' });
            }
        }
        return error.response;
    }
}
